module.exports = __webpack_public_path__ + "static/media/astronaut-ingravity.182ed063.svg";